export enum MerchantCategory {
    BANK = "BANK",
    LL = "LL",
    SPP = "SPP"
}

export enum ImageType {
    CAC2_AND_CAC7 = "CAC2ANDCAC7",
    DIRECTOR_VALID_ID_CARD  = "DIRECTOR_VALID_ID_CARD",
    MEMART  = "MEMART",
    GAZETTE  = "GAZETTE",
    GOVERNMENT_ISSUED_ID_CARD  = "GOVERNMENT_ISSUED_ID_CARD",
    UTILITY_BILL  = "UTILITY_BILL",
    BOARD_RESOLUTION_APPROVAL  = "BOARD_RESOLUTION_APPROVAL",
    CERTIFICATE_OF_INCORPORATION = "CERTIFICATE_OF_INCORPORATION",
}

export enum ResponseCode {
    INVALID_TOKEN = "95",
    SUCCESS = "0",
    CLIENT_NOT_ALLOWED = "97"
}

export enum Day {
    YESTERDAY = "YESTERDAY",
    TODAY = "TODAY",
    DAYS_7 = "DAYS_7",
    DAYS_30 =  "DAYS_30"
}